import React from 'react';
import ContentCard from './ContentCard';
import { withTranslation, Trans } from 'react-i18next';
import {Link} from "react-router-dom";
import emailImage from '../../assets/images/mail-envelope.png';

function AfterResetPasswordComponent(props) {

  return (
    <ContentCard title={<Trans i18nKey="check_email" />}>
      <img src={emailImage} className="d-block mx-auto w-50"/>
      <div className="mt-5">
        <div className="mb-2">
          <p>
            <Trans i18nKey="reset_password_email" />
          </p>
          {/* <button>Open my email</button>
          <p>Skip, I'll confirm later</p> */}
        </div>
        Didn't receive an email? Check your spam mailbox.
        <div className="mt-4 d-grid gap-2 col-9 mx-auto">
          <Link to="/" className="link text-center"><Trans i18nKey="back" /></Link>
        </div>
      </div>
    </ContentCard>
  );
}

export default withTranslation()(AfterResetPasswordComponent);
